import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { C, Btn } from "../components/UI";

export default function Empresas() {
  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  const [activeTab, setActiveTab] = useState(tabFromUrl || "cadastrar");
  const navigate = useNavigate();

  useEffect(() => {
    if (tabFromUrl) {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl]);
  
  return (
    <div style={{ minHeight: "100vh", background: C.background }}>
      {/* Hero Section */}
      <section style={{ 
        background: C.roseMid,
        padding: "60px 20px 20px",
        textAlign: "center"
      }}>
        <h1 style={{ 
          fontFamily: "'Playfair Display', serif",
          fontSize: 36,
          fontWeight: 700,
          color: "#fff",
          marginBottom: 24
        }}>
          Para Empresas
        </h1>

        {/* Tabs */}
        <div style={{ 
          display: "flex", 
          justifyContent: "center", 
          gap: 0,
          flexWrap: "wrap"
        }}>
          <button
            onClick={() => setActiveTab("cadastrar")}
            style={{
              padding: "16px 32px",
              fontSize: 16,
              fontWeight: 600,
              background: activeTab === "cadastrar" ? C.background : "transparent",
              color: activeTab === "cadastrar" ? C.roseMid : "#fff",
              border: "none",
              borderRadius: "12px 12px 0 0",
              cursor: "pointer",
              transition: "all 0.2s ease"
            }}
          >
            Cadastrar Empresa
          </button>
          <button
            onClick={() => setActiveTab("curriculos")}
            style={{
              padding: "16px 32px",
              fontSize: 16,
              fontWeight: 600,
              background: activeTab === "curriculos" ? C.background : "transparent",
              color: activeTab === "curriculos" ? C.roseMid : "#fff",
              border: "none",
              borderRadius: "12px 12px 0 0",
              cursor: "pointer",
              transition: "all 0.2s ease"
            }}
          >
            Currículos Cadastrados
          </button>
          <button
            onClick={() => setActiveTab("planos")}
            style={{
              padding: "16px 32px",
              fontSize: 16,
              fontWeight: 600,
              background: activeTab === "planos" ? C.background : "transparent",
              color: activeTab === "planos" ? C.roseMid : "#fff",
              border: "none",
              borderRadius: "12px 12px 0 0",
              cursor: "pointer",
              transition: "all 0.2s ease"
            }}
          >
            Planos
          </button>
        </div>
      </section>

      {/* Tab Content: Cadastrar */}
      {activeTab === "cadastrar" && (
        <section style={{ maxWidth: 700, margin: "0 auto", padding: "60px 20px" }}>
          <div style={{
            background: C.surface,
            borderRadius: 16,
            padding: 40,
            border: `1px solid ${C.border}`
          }}>
            <h2 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 26,
              color: C.roseMid,
              marginBottom: 12
            }}>
              Cadastre sua empresa na WoMom
            </h2>
            <p style={{ fontSize: 15, color: C.textSec, lineHeight: 1.7, marginBottom: 28 }}>
              Empresas cadastradas podem responder avaliacoes publicamente, divulgar vagas
              e mostrar para o mercado que sao lugares onde mulheres querem trabalhar.
            </p>

            <p style={{ fontSize: 14, fontWeight: 600, color: C.textMain, marginBottom: 14 }}>
              Com o perfil da empresa voce pode:
            </p>
            <ul style={{ listStyle: "none", padding: 0, margin: "0 0 28px 0", display: "flex", flexDirection: "column", gap: 12 }}>
              {[
                "Responder publicamente as avaliacoes que recebe",
                "Publicar vagas para um publico de talentos femininos",
                "Acompanhar como sua empresa e percebida por quem trabalhou nela",
                "Exibir seu perfil verificado nas buscas da plataforma"
              ].map(item => (
                <li key={item} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 14, color: C.textSec, lineHeight: 1.6 }}>
                  <span style={{ color: C.roseMid, flexShrink: 0 }}>&#9733;</span>
                  {item}
                </li>
              ))}
            </ul>

            <Btn
              variant="primary"
              onClick={() => navigate("/cadastro-empresa")}
              style={{ width: "100%", padding: "14px 24px", fontSize: 16 }}
            >
              Cadastrar minha empresa
            </Btn>

            <p style={{ fontSize: 13, color: C.textSec, textAlign: "center", marginTop: 18, lineHeight: 1.6 }}>
              O cadastro passa por conferencia da nossa equipe antes de ficar visivel no site.
            </p>
          </div>
        </section>
      )}

      {/* Tab Content: Currículos */}
      {activeTab === "curriculos" && (
        <section style={{ maxWidth: 900, margin: "0 auto", padding: "60px 20px" }}>
          <div style={{ 
            background: C.surface,
            borderRadius: 16,
            padding: 48,
            border: `1px solid ${C.border}`,
            textAlign: "center"
          }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📋</div>
            <h2 style={{ 
              fontFamily: "'Playfair Display', serif",
              fontSize: 28,
              color: C.roseMid,
              marginBottom: 12
            }}>
              Banco de Currículos
            </h2>
            <p style={{ fontSize: 16, color: C.textSec, marginBottom: 24, lineHeight: 1.6, maxWidth: 500, margin: "0 auto 24px" }}>
              Acesse currículos de profissionais qualificadas que buscam oportunidades em empresas comprometidas com diversidade e inclusão.
            </p>
            <p style={{ fontSize: 14, color: C.textSec, marginBottom: 24 }}>
              Para acessar o banco de currículos, sua empresa precisa estar cadastrada e ter um plano ativo.
            </p>
            <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
              <Btn variant="primary" onClick={() => setActiveTab("cadastrar")}>
                Cadastrar Empresa
              </Btn>
              <Btn variant="secondary" onClick={() => navigate("/login")}>
                Já tenho cadastro
              </Btn>
            </div>
          </div>

          <div style={{ marginTop: 40 }}>
            <h3 style={{ 
              fontFamily: "'Playfair Display', serif",
              fontSize: 22,
              color: C.roseMid,
              marginBottom: 24,
              textAlign: "center"
            }}>
              O que você encontra no banco de currículos
            </h3>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 20 }}>
              {[
                { icon: "👩‍💻", titulo: "Tecnologia", desc: "Desenvolvedoras, designers, analistas de dados e mais" },
                { icon: "📊", titulo: "Negócios", desc: "Gestoras, analistas financeiras, consultoras" },
                { icon: "🎨", titulo: "Criativo", desc: "Designers, redatoras, profissionais de marketing" },
                { icon: "⚖️", titulo: "Jurídico", desc: "Advogadas, analistas jurídicas, compliance" },
                { icon: "🏥", titulo: "Saúde", desc: "Profissionais da área de saúde e bem-estar" },
                { icon: "📚", titulo: "Educação", desc: "Professoras, coordenadoras, pedagogas" }
              ].map(item => (
                <div key={item.titulo} style={{
                  background: C.surface,
                  borderRadius: 12,
                  padding: 24,
                  border: `1px solid ${C.border}`
                }}>
                  <div style={{ fontSize: 28, marginBottom: 8 }}>{item.icon}</div>
                  <h4 style={{ fontSize: 16, fontWeight: 600, color: C.textMain, marginBottom: 6 }}>{item.titulo}</h4>
                  <p style={{ fontSize: 13, color: C.textSec, margin: 0 }}>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Tab Content: Planos */}
      {activeTab === "planos" && (
        <section style={{ maxWidth: 1100, margin: "0 auto", padding: "60px 20px" }}>
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: 40 }}>
            <h2 style={{ 
              fontSize: 20,
              fontWeight: 600,
              color: C.textMain,
              marginBottom: 20,
              lineHeight: 1.5
            }}>
              Conecte sua empresa com mulheres que buscam ambientes mais inclusivos, transparentes e alinhados com seus valores.
            </h2>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 15, color: C.textSec }}>✓ Aumente sua visibilidade</span>
              <span style={{ fontSize: 15, color: C.textSec }}>✓ Atraia candidatas qualificadas</span>
              <span style={{ fontSize: 15, color: C.textSec }}>✓ Fortaleça sua reputação</span>
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 24 }}>
            {[
              {
                nome: "PLANO BÁSICO",
                cor: "#22C55E",
                subtitulo: "Para empresas que estão começando",
                preco: "R$ 99,00",
                periodo: "/mês",
                destaque: false,
                recursos: [
                  "Página da empresa na WoMom",
                  "Recebimento de avaliações",
                  "Presença na busca",
                  "Perfil público"
                ]
              },
              {
                nome: "PLANO PROFISSIONAL",
                cor: "#EAB308",
                subtitulo: "Para empresas que querem atrair talentos",
                preco: "R$ 199,00",
                periodo: "/mês",
                destaque: true,
                recursos: [
                  "Tudo do Básico +",
                  "Publicação de vagas",
                  "Destaque nas buscas",
                  "Acesso a candidatas",
                  "Responder avaliações"
                ]
              },
              {
                nome: "PLANO PREMIUM",
                cor: "#EF4444",
                subtitulo: "Para empresas que querem crescer com estratégia",
                preco: "R$ 299,00",
                periodo: "/mês",
                destaque: false,
                recursos: [
                  "Tudo do Profissional +",
                  "Destaque premium (topo da lista)",
                  "Relatórios e insights",
                  "Personalização da página",
                  "Selo de empresa comprometida com mulheres"
                ]
              }
            ].map(plano => (
              <div key={plano.nome} style={{
                background: C.surface,
                borderRadius: 16,
                padding: 32,
                border: `1px solid ${C.border}`,
                position: "relative"
              }}>
                {plano.destaque && (
                  <div style={{
                    position: "absolute",
                    top: 16,
                    right: 16,
                    background: "#FEF3C7",
                    color: "#92400E",
                    padding: "4px 12px",
                    borderRadius: 20,
                    fontSize: 11,
                    fontWeight: 600
                  }}>
                    MAIS POPULAR
                  </div>
                )}
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                  <span style={{ 
                    width: 12, 
                    height: 12, 
                    borderRadius: "50%", 
                    background: plano.cor,
                    display: "inline-block"
                  }}></span>
                  <h3 style={{ 
                    fontSize: 16, 
                    fontWeight: 700, 
                    color: C.textMain,
                    margin: 0
                  }}>
                    {plano.nome}
                  </h3>
                  {plano.destaque && <span style={{ fontSize: 16 }}>⭐</span>}
                </div>
                <p style={{ 
                  fontSize: 14, 
                  color: C.textSec, 
                  marginBottom: 20,
                  fontWeight: 500
                }}>
                  {plano.subtitulo}
                </p>
                <ul style={{ listStyle: "disc", paddingLeft: 20, margin: "0 0 24px 0" }}>
                  {plano.recursos.map(recurso => (
                    <li key={recurso} style={{
                      padding: "6px 0",
                      fontSize: 14,
                      color: C.textSec
                    }}>
                      {recurso}
                    </li>
                  ))}
                </ul>
                <div style={{ marginBottom: 16 }}>
                  <span style={{ fontSize: 14, marginRight: 4 }}>💰</span>
                  <span style={{ 
                    fontSize: 18, 
                    fontWeight: 700, 
                    color: C.textMain
                  }}>
                    {plano.preco}
                  </span>
                  <span style={{ 
                    fontSize: 14, 
                    color: C.textSec 
                  }}>
                    {plano.periodo}
                  </span>
                </div>
                <div 
                  style={{ 
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    cursor: "pointer",
                    color: C.roseMid,
                    fontWeight: 500,
                    fontSize: 14
                  }}
                  onClick={() => setActiveTab("cadastrar")}
                >
                  <span>👉</span>
                  <span>[ Começar agora ]</span>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
